module.exports = __webpack_public_path__ + "img/servicio-intermunicipal.bd82becc.png";